export default "__VITE_ASSET__UtTsIwAd__"